/* ==========================================================================
   BIONIKA — termékoldali kiegészítések a Dawn 15.x variáns-architektúrán
   --------------------------------------------------------------------------
   A Dawn 11-ben ezek a `VariantSelects` osztály saját metódusai voltak
   (markaAtmeroValasztek / premetKeszlet / updateVirtualVariantPicker).
   A Dawn 14-től a variánsváltást a `product-info` elem intézi: a szekciót a
   szerver újrarendereli, majd kiadja a `variantChange` eseményt. Ezért itt
   már nem felülírunk semmit, csak feliratkozunk az eseményre.
   ========================================================================== */
(function () {
  function premetKeszlet(variant) {
    var box = document.querySelector('#premet-keszlet-element');
    var dataEl = document.querySelector('#variant_premet_keszlet');
    if (!box || !dataEl) return;

    // Részleges vagy érvénytelen választásnál nincs konkrét készlet.
    if (!variant) {
      box.classList.add('hide_premet');
      return;
    }

    var stock;
    try {
      stock = parseInt(JSON.parse(dataEl.textContent)[variant.id], 10);
    } catch (e) {
      box.classList.add('hide_premet');
      return;
    }

    if (stock > 0) {
      box.classList.remove('hide_premet');
      var span = box.querySelector('span');
      if (span) {
        span.innerText = 'Budapesti 4 órás kiszállítási lehetőséghez elérhető készlet: ' + stock + ' db';
      }
    } else {
      box.classList.add('hide_premet');
    }
  }

  function markaAtmeroValasztek(variant) {
    if (!variant) return;
    var href = window.location.href;
    if (
      href.indexOf('3d-builder') === -1 &&
      href.indexOf('titanhalok-41') === -1 &&
      href.indexOf('tortcsavarkiszedo-keszlet') === -1
    ) {
      return;
    }
    if (typeof marka_atmero_render === 'function') marka_atmero_render(variant);
  }

  // A picker markupját a szekció-újrarenderelés már lecserélte, csak
  // újra kell kötni rá az eseménykezelőket.
  function refreshVirtualVariantPicker(root) {
    if (typeof initVirtualVariantPicker !== 'function') return;
    (root || document).querySelectorAll('.virtual-variant-picker').forEach(initVirtualVariantPicker);
  }

  function runAll(variant, root) {
    premetKeszlet(variant);
    markaAtmeroValasztek(variant);
    refreshVirtualVariantPicker(root);
  }

  /* ==========================================================================
     BIONIKA — csak a ténylegesen megérintett opciók maradjanak kijelölve
     --------------------------------------------------------------------------
     A Dawn 15 minden opcióváltásnál újrarendereli a szekciót a szerverrel
     (`?option_values=…`). A Shopify a részleges választásból is feloldja a
     legközelebbi variánst, és a válaszban MINDEN opció ki van jelölve — így egy
     méret kiválasztása után az átmérő és a sulkus is „magától" beállna. Egy
     fogtechnikai katalógusban ez téves rendeléshez vezet, ezért a vissza nem
     igazolt opciócsoportok jelölését levesszük.

     A „megérintett" halmazt a product-info elemen tartjuk (ez a csere során
     megmarad), és betöltéskor feltöltjük a már bejelölt csoportokkal — így a
     ?variant=… mélylink továbbra is teljes választásnak számít.
     ========================================================================== */

  function optionNameOf(target) {
    if (!target) return null;
    if (target.tagName === 'SELECT') {
      var opt = target.selectedOptions && target.selectedOptions[0];
      return opt ? opt.dataset.optionName || null : null;
    }
    return target.dataset ? target.dataset.optionName || null : null;
  }

  function touchedSet(productInfo) {
    if (!productInfo._bnkTouchedOptions) productInfo._bnkTouchedOptions = {};
    return productInfo._bnkTouchedOptions;
  }

  // A friss variant-selects: a viewTransition a régit display:none-nal még
  // ~500 ms-ig a DOM-ban hagyja, azt ki kell hagyni.
  function liveVariantSelects(productInfo) {
    var all = productInfo.querySelectorAll('variant-selects');
    for (var i = 0; i < all.length; i++) {
      if (all[i].style.display !== 'none') return all[i];
    }
    return null;
  }

  function optionGroups(variantSelects) {
    return Array.from(variantSelects.querySelectorAll('fieldset.product-form__input')).map(function (fs) {
      var input = fs.querySelector('[data-option-name]');
      return { fieldset: fs, name: input ? input.dataset.optionName : null };
    });
  }

  // Betöltéskor / termékcserénél: ami már be van jelölve, az a vásárló választása.
  // A quick-add modál futásidőben injektálja a termékszekciót, ezért a vetést
  // az első interakciónál is elvégezzük (akkor még a csere ELŐTTI állapot látszik).
  function seedTouched(productInfo) {
    if (productInfo._bnkSeeded) return;
    productInfo._bnkSeeded = true;
    var vs = liveVariantSelects(productInfo);
    if (!vs) return;
    var touched = touchedSet(productInfo);
    optionGroups(vs).forEach(function (g) {
      var checked = g.fieldset.querySelector('input:checked');
      if (g.name && checked) touched[g.name] = checked.value;
    });
    // A legördülőknél megtartjuk a Dawn kijelölését (a 15-ös
    // updateSelectionMetadata() a `selected` attribútumra épít), ezért azok
    // mindig választottnak számítanak — ez a Dawn 11-es viselkedés is volt.
    vs.querySelectorAll('.product-form__input--dropdown select').forEach(function (sel) {
      var name = optionNameOf(sel);
      if (name) touched[name] = sel.value;
    });
  }

  // A választás ÉRVÉNYRE JUTTATÁSA tetszőleges gyökéren — a `root` lehet a DOM-ba
  // még be nem szúrt, frissen letöltött csomópont is. Így nincs villanás.
  //
  // Két dolgot csinál:
  //  1. amit a vásárló NEM választott, arról leveszi a szerver előjelölését;
  //  2. amit VÁLASZTOTT, azt visszateszi. A (2) azért kell, mert ha a választott
  //     kombinációhoz nincs variáns (ilyen termék pl. az anatómiai fej: csak
  //     bizonyos átmérő+hossz párok léteznek), a szerver egy olyan szekciót ad
  //     vissza, amiben SEMMI nincs kijelölve — és a csere után a vásárló saját
  //     kattintásai is eltűntek.
  // Visszatér: igaz, ha maradt kiválasztatlan opciócsoport.
  function clearUntouchedIn(root, productInfo) {
    if (!root) return false;
    var vs = root.matches && root.matches('variant-selects') ? root : root.querySelector('variant-selects');
    if (!vs) return false;
    var touched = touchedSet(productInfo);
    var incomplete = false;

    optionGroups(vs).forEach(function (g) {
      if (!g.name) return;
      var valasztott = touched[g.name];
      var label = g.fieldset.querySelector('[data-selected-value]');

      if (valasztott === undefined) {
        incomplete = true;
        g.fieldset.querySelectorAll('input:checked').forEach(function (input) {
          input.checked = false;
          input.removeAttribute('checked');
        });
        if (label) label.textContent = '';
        return;
      }

      // Visszaállítjuk a vásárló választását (a szerver akár mást, akár semmit ad).
      var talalt = false;
      g.fieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var kell = input.value === valasztott;
        input.checked = kell;
        if (kell) {
          input.setAttribute('checked', 'checked');
          talalt = true;
        } else {
          input.removeAttribute('checked');
        }
      });
      if (talalt && label) label.textContent = valasztott;
      // Ha az érték már nem is szerepel a listában, a csoport újra választatlan.
      if (!talalt && g.fieldset.querySelector('input[type="radio"]')) {
        delete touched[g.name];
        incomplete = true;
        if (label) label.textContent = '';
      }
    });

    // Legördülőknél a `selected` attribútum hordozza az állapotot.
    vs.querySelectorAll('.product-form__input--dropdown select').forEach(function (sel) {
      var name = optionNameOf(sel) || (sel.options[0] && sel.options[0].dataset.optionName);
      var valasztott = name ? touched[name] : undefined;
      if (valasztott === undefined) return;
      Array.prototype.forEach.call(sel.options, function (opt) {
        if (opt.value === valasztott) {
          opt.setAttribute('selected', 'selected');
          sel.value = valasztott;
        } else {
          opt.removeAttribute('selected');
        }
      });
    });

    return incomplete;
  }

  /* ---- Helyfoglalás, ha a kombinációhoz nincs variáns ----------------------
     A Dawn ilyenkor `display: none`-nal rejti az árat, a cikkszámot és a
     készlet-jelzést, amitől a panel összeugrik (mérve: a kosárgomb 90 px-et
     lépett). A dobozokat a folyamatban tartjuk (a CSS `visibility: hidden`-t
     ad rájuk), de a `display`-t NEM szabad előírni: a cikkszám pl. inline-flex,
     és `block`-ra kényszerítve önmagában 49 px eltolódást okozott. Ezért az
     elem SAJÁT megjelenítési módját jegyezzük meg még látható állapotban, és
     azt adjuk vissza inline stílusként. ---- */
  var FOGLALT = '[id^="price-"], [id^="Sku-"], [id^="Inventory-"]';

  function helyfoglalas(productInfo, nincsVarians) {
    var cont = productInfo.querySelector('.product__info-container');
    if (!cont) return;
    cont.querySelectorAll(FOGLALT).forEach(function (el) {
      if (nincsVarians) {
        if (el._bnkDisplay) el.style.setProperty('display', el._bnkDisplay, 'important');
      } else {
        // Látható állapotban jegyezzük meg a természetes megjelenítési módot.
        var d = getComputedStyle(el).display;
        if (d && d !== 'none') el._bnkDisplay = d;
        el.style.removeProperty('display');
      }
    });
  }

  // A product-info a beszúrás ELŐTT lefuttatja a preProcess visszahívásokat a
  // friss csomóponton — ide kötjük be a jelölés levételét.
  function attachPreProcess(productInfo) {
    if (productInfo._bnkPreProcessBound || typeof productInfo.addPreProcessCallback !== 'function') return;
    productInfo._bnkPreProcessBound = true;
    productInfo.addPreProcessCallback(function (node) {
      clearUntouchedIn(node, productInfo);

      // Van-e egyáltalán variáns a beérkező szekcióban? FONTOS: ezt NEM lehet a
      // `variantChange` eseményből tudni — a Dawn `handleUpdateProductInfo`-ja
      // variáns híján `setUnavailable()` után KILÉP, és nem publikálja az
      // eseményt. A friss markup viszont hordozza a választott variáns JSON-t.
      var jelolo = node.querySelector
        ? node.querySelector('[data-selected-variant]')
        : null;
      var vanVarians = false;
      if (jelolo) {
        try {
          vanVarians = !!JSON.parse(jelolo.textContent);
        } catch (e) {
          vanVarians = false;
        }
      }
      // Ha nincs `[data-selected-variant]` a csomópontban (pl. termékcsere teljes
      // oldallal), ne kapcsolgassunk feleslegesen.
      if (jelolo) {
        productInfo.classList.toggle('bnk-no-variant', !vanVarians);
        helyfoglalas(productInfo, !vanVarians);
      }
    });
  }

  function clearUntouchedOptions(productInfo) {
    // A beszúrás előtti horog már elvégezte a láthatót; ez a biztonsági háló,
    // és innen jönnek a DOM-hoz kötött részek (rejtett variáns-id, URL).
    var incomplete = clearUntouchedIn(liveVariantSelects(productInfo), productInfo);

    if (!incomplete) return;

    // Hiányos választásnál ne lehessen a szerver által kitalált variánst
    // kosárba tenni; a gomb aktív marad, kattintásra a product-form.js adja
    // a „Kérem válasszon opciót!" jelzést.
    productInfo
      .querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"], .installment input[name="id"]')
      .forEach(function (input) {
        input.value = '';
      });

    // A Dawn a kitalált variánst az URL-be is beírja (updateURL). Hiányos
    // választásnál ezt visszavesszük, különben egy megosztott/újratöltött link
    // olyan variánst mutatna, amit a vásárló nem választott ki.
    if (productInfo.dataset.updateUrl === 'true') {
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.has('variant')) {
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url.toString());
        }
      } catch (e) {
        /* régi böngésző: nem kritikus */
      }
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var vs = event.target.closest && event.target.closest('variant-selects');
      if (!vs) return;
      var productInfo = vs.closest('product-info');
      if (!productInfo) return;
      seedTouched(productInfo);
      attachPreProcess(productInfo);
      var name = optionNameOf(event.target);
      // Az ÉRTÉKET is megjegyezzük, nem csak azt, hogy hozzányúlt: a szerver
      // nem létező kombinációnál üres kijelöléssel válaszol, abból nem lehetne
      // helyreállítani a vásárló választását.
      if (name) touchedSet(productInfo)[name] = event.target.value;
    },
    true
  );

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data ? event.data.variant : null;
      var root = event && event.data ? document.getElementById('ProductInfo-' + event.data.sectionId) : null;
      // A szekciócsere a következő tick-ben fejeződik be.
      setTimeout(function () {
        var productInfo = (root && root.closest('product-info')) || document.querySelector('product-info');
        if (productInfo) clearUntouchedOptions(productInfo);
        runAll(variant, root || undefined);
      }, 0);
    });
  }

  // A quick-add modálban futásidőben jön létre a product-info; ott ez az esemény
  // ér el minket. (A termékoldalon a betöltéskori végigjárás intézi, mert ez a
  // szkript defer-rel tölt, tehát a connectedCallback már lefutott.)
  document.addEventListener('product-info:loaded', function (event) {
    var productInfo = event.target;
    if (productInfo && productInfo.tagName === 'PRODUCT-INFO') {
      seedTouched(productInfo);
      attachPreProcess(productInfo);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('product-info').forEach(function (productInfo) {
      seedTouched(productInfo);
      attachPreProcess(productInfo);
      // Kezdeti (látható) állapotban rögzítjük a természetes display-értékeket.
      helyfoglalas(productInfo, false);
    });

    var el = document.querySelector('[data-bnk-initial-variant]');
    var variant = null;
    if (el) {
      try {
        variant = JSON.parse(el.getAttribute('data-bnk-initial-variant'));
      } catch (e) {
        variant = null;
      }
    }
    runAll(variant);
  });
})();

/* ==========================================================================
   BIONIKA — termékkép natív-méret plafon: ITT NINCS TÖBBÉ JS.

   A plafont a SZERVER adja: a `product-thumbnail.liquid` és a
   `product-media.liquid` `--bnk-native-w/h` CSS-változóban kiírja a kép valódi
   méretét, a `bionika-product-modern.css` pedig ebből számol
   `max-width: min(100%, …)`-et. Így a korlát az ELSŐ festéskor él.

   A korábbi, `load` eseményre futó JS-ág törölve (2026-07-31), két okból:
   1. Csak betöltés UTÁN érvényesült — a kép előbb szétnyúlt, majd visszaugrott.
   2. TÉVEDETT is: a `naturalWidth < a kért width=` feltétel akkor is igaz, ha a
      böngésző pusztán egy kisebb srcset-jelöltet töltött le egy nagy eredetiből
      (mérve: 1000 px-es forrásból 703 px-es változat egy 779 px-es oszlopban) —
      ilyenkor 703 px-re szűkítette a képet, feleslegesen.
   A Shopify tárolt kép-metaadata pontos (49 véletlen médián ellenőrizve:
   0 eltérés), ezért nincs szükség kliensoldali méréssel korrigálni.
   ========================================================================== */
